import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material'
import { useEffect, useState } from 'react'

type SaveAsPolicyDialogProps = {
  open: boolean
  permissionCount: number
  onCancel: () => void
  onConfirm: (name: string) => Promise<void> | void
}

const SaveAsPolicyDialog = ({ open, permissionCount, onCancel, onConfirm }: SaveAsPolicyDialogProps) => {
  const [name, setName] = useState('')
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (open) {
      setName('')
      setSubmitting(false)
    }
  }, [open])

  const trimmed = name.trim()
  const canConfirm = trimmed.length > 0 && permissionCount > 0 && !submitting

  return (
    <Dialog open={open} onClose={onCancel} fullWidth maxWidth="xs">
      <DialogTitle>Save as policy</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Save the current set of {permissionCount} permission{permissionCount === 1 ? '' : 's'} as a reusable policy.
        </DialogContentText>
        <TextField
          fullWidth
          size="small"
          label="Policy name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          onKeyDown={async (event) => {
            if (event.key === 'Enter' && canConfirm) {
              setSubmitting(true)
              try {
                await onConfirm(trimmed)
              } finally {
                setSubmitting(false)
              }
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={!canConfirm}
          onClick={async () => {
            setSubmitting(true)
            try {
              await onConfirm(trimmed)
            } finally {
              setSubmitting(false)
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SaveAsPolicyDialog
